import httpClient from './httpClient'

class POICategoryApi {
  static async getCategory() {
    try {
      const res = await httpClient.get(`/poi_category`)
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  }

  static async getSubcategory(poiCategoryId) {
    try {
      const res = await httpClient.get(
        `/poi_category/${poiCategoryId}/poi_sub_category`,
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  }

  static async getSubcategoryValues(poiCategoryId, poiSubategoryId) {
    try {
      const res = await httpClient.get(
        `/poi_category/${poiCategoryId}/poi_sub_category/${poiSubategoryId}/value`,
      )
      return res.data
    } catch (e) {
      console.log(e)
      throw e
    }
  }
}

export default POICategoryApi
